export default __webpack_public_path__ + "static/media/white-event-tickets-music.d7f13bbf.png";